var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMissingInfoHeaderIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48.3127,
    height: 48,
    rx: 17,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M31.7904 18.2867C31.0003 18.2867 29.9537 18.2692 28.6506 18.2692C25.4727 18.2692 22.8597 15.639 22.8597 12.4313V6.80325C22.8597 6.3605 22.5062 6 22.0678 6H12.8113C8.49154 6 5 9.5455 5 13.8907V32.747C5 37.3057 8.65789 41 13.1718 41H26.956C31.2602 41 34.75 37.4772 34.75 33.1285V19.0743C34.75 18.6298 34.3982 18.271 33.9581 18.2727C33.2182 18.278 32.331 18.2867 31.7904 18.2867Z",
    fill: "#FFAC30"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M27.022 6.99278C26.4987 6.44853 25.5852 6.82303 25.5852 7.57727V12.192C25.5852 14.1275 27.1795 15.72 29.115 15.72C30.3347 15.734 32.0287 15.7375 33.4672 15.734C34.204 15.7323 34.5785 14.852 34.0675 14.32C32.2212 12.4003 28.9155 8.95977 27.022 6.99278Z",
    fill: "#FFAC30"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5793 22.4283H20.5031C21.2223 22.4283 21.8068 21.8455 21.8068 21.1263C21.8068 20.407 21.2223 19.8225 20.5031 19.8225H14.5793C13.8601 19.8225 13.2773 20.407 13.2773 21.1263C13.2773 21.8455 13.8601 22.4283 14.5793 22.4283ZM14.5795 31.1681H24.1065C24.8257 31.1681 25.4102 30.5854 25.4102 29.8661C25.4102 29.1469 24.8257 28.5624 24.1065 28.5624H14.5795C13.8602 28.5624 13.2775 29.1469 13.2775 29.8661C13.2775 30.5854 13.8602 31.1681 14.5795 31.1681Z",
    fill: "#FFAC30"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMissingInfoHeaderIcon);
export default __webpack_public_path__ + "static/media/MissingInfoHeaderIcon.fa8d8a27aa993733d315105a06aca0f8.svg";
export { ForwardRef as ReactComponent };